/**
 * marketService.js — Live activity feed (game_end + melee highlights).
 */
import { apiClient } from "./api";

export const marketService = {
  // Returns { items: [...], next_cursor: string|null }. Pass `before`
  // from the previous response's `next_cursor` to fetch the next page.
  // `sinceMinutes` filters out posts older than the given window - the
  // dashboard panel passes 60 to keep the feed "live" only.
  getFeed: ({ limit = 20, before = null, sinceMinutes = null } = {}) => {
    const qs = new URLSearchParams();
    qs.set("limit", String(limit));
    if (before) qs.set("before", before);
    if (sinceMinutes) qs.set("since_minutes", String(sinceMinutes));
    return apiClient.get(`/market-feed?${qs.toString()}`).then((r) => r.data);
  },
};
